const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;
  let visibleCount = 0;

  const elementData = animationTriggerElements.map(element => {
    let isVisible = false;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const wasVisible = isVisible;
        isVisible = entry.isIntersecting;
        if (isVisible && !wasVisible) visibleCount++;
        if (!isVisible && wasVisible) visibleCount--;
      });
    }, {
      rootMargin: '100px 0px 100px 0px'
    });
    observer.observe(element);
    
    return { element, get isVisible() { return isVisible; } };
  });

  const updateAllZooms = () => {
    if (visibleCount <= 0) return;
    const viewportHeight = window.innerHeight;
    
    elementData.forEach(({ element, isVisible }) => {
      if (!isVisible) return;
      
      const rect = element.getBoundingClientRect();
      const elementHeight = rect.height;
      const elementTop = rect.top;
      
      let percentage = 0;
      if (elementTop < viewportHeight && elementTop + elementHeight > 0) {
        const distance = viewportHeight - elementTop;
        percentage = Math.round(distance / ((viewportHeight + elementHeight) / 100));
      }
      
      percentage = Math.max(0, Math.min(100, percentage));
      element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentage);
    });
  };

  let rafId = null;
  const onScroll = () => {
    if (rafId || visibleCount <= 0) return;
    rafId = requestAnimationFrame(() => {
      updateAllZooms();
      rafId = null;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  updateAllZooms(); // Initial call
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
